import { createFileRoute } from '@tanstack/react-router';
import GoodEdit from '../../../features/baseData/goods/good/edit';
import {
  createPermissionGuard,
  getPermissionSet,
  GOODS_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/gueter/$goodId_/bearbeiten')({
  component: GoodEdit,
  beforeLoad: createPermissionGuard(
    getPermissionSet(GOODS_PERMISSIONS, 'EDIT'),
  ),
});

export const EditGoodRoute = Route;
